var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9807 7.56251H7.12428V11.3855C7.12428 12.001 6.62092 12.5 6 12.5C5.37908 12.5 4.87572 12.001 4.87572 11.3855V7.56251H1.01932C0.440134 7.50305 0 7.01921 0 6.44198C0 5.86475 0.440134 5.38092 1.01932 5.32146H4.86363V1.51048C4.92361 0.936318 5.41167 0.5 5.99396 0.5C6.57624 0.5 7.0643 0.936318 7.12428 1.51048V5.32146H10.9807C11.5599 5.38092 12 5.86475 12 6.44198C12 7.01921 11.5599 7.50305 10.9807 7.56251Z",
    fill: "#3E7EEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePlus);
export default __webpack_public_path__ + "static/media/blue-plus.cf51ff4caa271570bd1cb52a6bef2223.svg";
export { ForwardRef as ReactComponent };